import styled from 'styled-components'
import { TextBody } from '../../styles/vars/textStyles.style'
import { mq } from '../../styles/vars/media-queries.style'
import { colors } from '../../styles/vars/colors.style'
import { FormInputLabel, FormInputElement } from '../Forms/input/index.style'
import { RichTextMain } from '../RichText/index.style'
import { easings } from '../../styles/vars/easings.style'

export const NewsletterWrapper = styled.div`
  height: 100%;
  overflow: hidden;
  position: relative;
`

export const NewsletterInner = styled.div`
  align-content: center;
  align-items: center;
  background-color: ${({ background }) => `${background}`};
  display: flex;
  height: 100%;
  flex-direction: column;
  /* justify-content: center; */
  position: relative;
  text-align: left;
`

export const NewsletterText = styled.div`
  width: 100%;
  z-index: 1;

  ${mq.desk} {
    ${TextBody} {
      max-width: 83rem;
    }
  }
`

export const NewsletterSubmitMessage = styled.form`
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.5s;

  ${({ formHidden }) => {
    return formHidden
      ? `
      opacity: 1; 
      pointer-events:all;`
      : `
      opacity: 0; 
      pointer-events:none;`
  }}
`

export const NewsletterForm = styled.form`
  transition: opacity 0.5s;

  ${({ formHidden }) => {
    return formHidden
      ? `
        opacity: 0; 
        pointer-events:none;

        ${FormInputLabel},
        ${FormInputElement} {
          cursor: default;
          pointer-events:none;
        }`
      : `
        opacity: 1; 
        pointer-events:all;`
  }}

  ${RichTextMain} {
    a {
      transition: color 0.15s ${easings.inOut.quart};

      :hover {
        color: ${colors.hotPink};
      }
    }
  }
`
export const NewsletterFormInner = styled.div`
  ${mq.tabletL} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2.4rem;
  }
`

export const NewsletterInputWrap = styled.div`
  position: relative;
  order: ${({ desktopOrder }) => `${desktopOrder}`};
  pointer-events: none;

  ${mq.tabletL} {
    display: inline-block;
  }
`

export const NewsletterImg = styled.div`
  display: none;

  ${mq.tabletL} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`
export const NewsletterImageWrap = styled.div`
  border-radius: 0.6rem;
  display: none;
  overflow: hidden;
  position: relative;

  ${mq.tabletL} {
    display: block;
  }
`
